import { shallowReadonly, shallowRef } from 'vue';
import { planService } from '@/services/plan';
import { log } from '@/Utils/logger';

const allPlanNames = shallowRef<readonly string[]>([]);

export const useAllPlanNames = () => {
  planService
    .fetchAllPlanNames()
    .then((received) => (allPlanNames.value = received))
    .catch((error) => log.error({ func: 'useAllPlanNames', error }, 'failed to fetch all plan names'));

  return shallowReadonly(allPlanNames);
};
